import { Readable } from "node:stream";
import { a as waitUntilWorkflowInProgress, g as getWorkflowJob, p as pollWorkflowJob } from "../../../../../../../chunks/octokit.js";
import { u as updateInstallerProgress } from "../../../../../../../chunks/utils.js";
import { g as get, I as InstallerCollection } from "../../../../../../../chunks/firebase.js";
const syncInstallerProgress = async (email, controller) => {
  try {
    const workflow = await waitUntilWorkflowInProgress(`user/${email}`);
    const job = await getWorkflowJob(workflow.id);
    await pollWorkflowJob(
      job.id,
      async ({ status, steps }) => {
        const completed = steps?.filter((step2) => step2.status === "completed").length;
        const step = steps?.find((step2) => step2.status === "in_progress")?.name;
        const total = steps?.length;
        const progress = `${completed} / ${total}`;
        const installer = await get(InstallerCollection(), email);
        if (installer.data && !installer.data.cancelled) {
          updateInstallerProgress(email, {
            progress,
            status,
            step: step ?? "None"
          });
        }
        if (!installer.data || status === "completed") {
          controller.abort();
        }
      },
      5e3,
      controller.signal
    );
  } catch (err) {
    console.log(err);
  }
};
const GET = async ({ locals }) => {
  const email = locals.user?.email;
  const installer = await get(InstallerCollection(), email);
  const controller = new AbortController();
  const stream = new Readable({
    read() {
    },
    signal: controller.signal
  });
  const unsubscribe = installer.ref.onSnapshot(
    (doc) => {
      const data = `event: update
data: ${JSON.stringify(doc.data())}

`;
      stream.push(data);
    },
    (error) => {
      const errorData = `event: error
data: ${JSON.stringify({ message: error.message })}

`;
      stream.push(errorData);
    }
  );
  syncInstallerProgress(email, controller).then(() => console.log("Synced installer progress"));
  stream.on("close", () => {
    controller.abort();
    unsubscribe();
  });
  return new Response(stream, {
    headers: {
      "Content-Type": "text/event-stream",
      "Cache-Control": "no-cache",
      Connection: "keep-alive"
    }
  });
};
export {
  GET
};
